import LocationPicker from './LocationPicker.component';
export default LocationPicker;